import {
  asBoolean,
  asDate,
  asNumber,
  asString,
  isObject,
  parseList,
} from "./model-utils";
import { Author } from "./author";
import { ChatMedia } from "./chat-media";
import { EventBundle } from "./event-bundle";
import { EventLocation } from "./event-location";
import { Host } from "./host";
import { TrackLink } from "./track-link";
import { enumValue, AccessLevel, EventStatus, ProfileType } from "./enums";

export class Event {
  [key: string]: any;
  constructor(json: any = {}) {
    Object.assign(this, json);
    this.eventId = asString(json.eventId);
    this.mandatory = asBoolean(json.mandatory);
    this.paidEvent = asBoolean(json.paidEvent);
    this.postAsComment = asBoolean(json.postAsComment);
    this.mapFound = asBoolean(json.mapFound);
    this.name = asString(json.name);
    this.eventType = asString(json.eventType);
    this.orgId = asString(json.orgId);
    this.orgName = asString(json.orgName);
    this.groupId = asString(json.groupId);
    this.groupName = asString(json.groupName);
    this.description = asString(json.description);
    this.amount = asNumber(json.amount);
    this.currency = asString(json.currency);
    this.country = asString(json.country);
    this.address = asString(json.address);
    this.numberOfPerson = asNumber(json.numberOfPerson);
    this.webLink = asString(json.webLink);
    this.mapUrl = asString(json.mapUrl);
    this.totalAttendees = asNumber(json.totalAttendees);
    this.totalRegistered = asNumber(json.totalRegistered);
    this.publishPayment = asNumber(json.publishPayment);
    this.startDate = asDate(json.startDate);
    this.endDate = asDate(json.endDate);
    this.startTime = asString(json.startTime);
    this.endTime = asString(json.endTime);
    this.dayDuration = asNumber(json.dayDuration);
    this.status = enumValue(EventStatus, json.status);
    this.tinyUrl = asString(json.tinyUrl);
    this.profileId = asString(json.profileId);
    this.profileType = enumValue(ProfileType, json.profileType);
    this.timezone = asString(json.timezone);
    this.maxTicketPerUser = asNumber(json.maxTicketPerUser) ?? 10;
    this.checkSum = asString(json.checkSum);
    this.accessLevel = enumValue(AccessLevel, json.accessLevel);
    this.author = Author.fromJson(json.author);
    this.host = Host.fromJson(json.host);
    this.location = EventLocation.fromJson(json.location);
    this.media = parseList(json.media, ChatMedia.fromJson);
    this.bundles = parseList(json.bundles, EventBundle.fromJson);
    this.trackLink = parseList(json.trackLink, TrackLink.fromJson);
    this.tags = Array.isArray(json.tags) ? json.tags.map(String) : [];
  }

  get isPaid() {
    return this.paidEvent === true;
  }

  get isActive() {
    return this.status === EventStatus.ACTIVE;
  }

  get isInactive() {
    return this.status === EventStatus.INACTIVE;
  }

  get isPublic() {
    return this.accessLevel === AccessLevel.PUBLIC;
  }

  get isPrivate() {
    return this.accessLevel === AccessLevel.PRIVATE;
  }

  static fromJson(json: any) {
    return isObject(json) ? new Event(json) : json;
  }
}
